import styled from 'styled-components';

import { ContainerProps } from './SensorNodeWidget.utils';

export const SensorNodeWidgetContainer = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  text-align: center;

  .sensor-values-container {
    display: flex;
    gap: 15px;
    ${({ $isCombo }) => ($isCombo ? 'min-width: 100px;' : '')}
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
  }

  .value-container {
    display: flex;
    text-align: center;
    align-items: baseline;

    .value {
      flex-shrink: 0;
      font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }

    .label {
      flex-shrink: 0;
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      color: ${({ theme: { token } }) => token.colorTextTertiary};
      margin-left: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }
`;
